/**
 * MediaContent — Elemento de mídia estável para a AdsSidebar.
 *
 * Renderiza UM <img> e UM <video> permanentes cujo .src é trocado via ref pelo
 * useAdsTimer — sem remontagem, sem key={midia.id}. TV Boxes ARM têm poucos cores;
 * destruir e recriar nós de vídeo a cada story gera picos de GC com jank visível.
 *
 * Visibilidade controlada por `isVideo`:
 *   • Ativo:   `visible`  — recebe src e é exibido
 *   • Inativo: `invisible` — preserva o nó no DOM (sem layout thrash) mas oculto
 *
 * O autoPlay + muted + playsInline são obrigatórios no Chromium embarcado para
 * respeitar a política de autoplay sem gesto do usuário.
 */

import type React from 'react';
import type { Midia } from '@/shared/types';

interface Props {
  midia:            Midia | null;
  isVideo:          boolean;
  videoRef:         React.RefObject<HTMLVideoElement | null>;
  imgRef:           React.RefObject<HTMLImageElement | null>;
  onLoadedMetadata: () => void;
}

export default function MediaContent({ midia, isVideo, videoRef, imgRef, onLoadedMetadata }: Props) {
  return (
    <>
      <img
        ref={imgRef}
        alt={midia?.titulo ?? ''}
        className={`absolute inset-0 w-full h-full object-cover${isVideo ? ' invisible' : ''}`}
      />
      <video
        ref={videoRef}
        className={`absolute inset-0 w-full h-full object-cover${!isVideo ? ' invisible' : ''}`}
        autoPlay
        muted
        playsInline
        onLoadedMetadata={onLoadedMetadata}
      />
    </>
  );
}
